import { render } from "./DashboardPanel.vue?vue&type=template&id=26efcd14&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"

import "./DashboardPanel.vue?vue&type=style&index=0&id=26efcd14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26efcd14"]])

export default __exports__